import { StructureChildrenLoader, StructureNode, StructureDTO, StructureConfig, StructureItem } from './model/structure-node';
import type { HttpService } from '../App/services/http-service';
import { StructureNavigationItemImplementation } from '../Shell/PandoraSolutionBuilderAgent/model/enumerations';

export class StructuresService {
	static readonly $inject = ['mx.SolutionBuilderAgent.Http'];

	constructor(private readonly http: HttpService) {}

	getStructure(item: StructureItem, children?: StructureDTO[], parent?: StructureNode) {
		const childrenLoader: StructureChildrenLoader = (node: StructureNode) => this.getStructureChildren(node);
		const structure = new StructureNode(item);

		const childrenNodes = children?.map(({ Name: name, NodeId: nodeId, Icon: icon, Children: children }) =>
			this.getStructure({ config: item.config, name, icon, nodeId }, children, structure)
		);

		structure.initTree({ childrenLoader, parent, children: childrenNodes });

		return structure;
	}

	async getStructureChildren(structure: StructureNode): Promise<StructureNode[]> {
		const { config, nodeId } = structure;
		return (await this.loadStructures(config, nodeId)).map(({ Name: name, Icon: icon, NodeId: nodeId, Children: children }) => {
			return this.getStructure({ config, name, icon, nodeId }, children, structure);
		});
	}

	private async loadStructures({ implementationType, widgetId, relativePath }: StructureConfig, nodeId: string): Promise<StructureDTO[]> {
		switch (implementationType) {
			case StructureNavigationItemImplementation.DataDefinition:
				return await this.dataDefinitionChildrenLoader(widgetId, nodeId);
			case StructureNavigationItemImplementation.ServiceOperation:
				return await this.serviceChildrenLoader(relativePath, widgetId, nodeId);
		}
	}

	private async dataDefinitionChildrenLoader(widgetId: string, nodeId: string): Promise<StructureDTO[]> {
		return await this.http.get(`api/Navigation/Children/${widgetId}/${nodeId}`);
	}

	private async serviceChildrenLoader(relativePath: string, widgetId: string, nodeId: string): Promise<StructureDTO[]> {
		return await this.http.get<StructureDTO[]>(this.buildPath(relativePath, { widgetId, nodeId }));
	}

	private buildPath(relativePath: string, params: Record<string, string>) {
		return Object.entries(params).reduce((path, [key, value]) => {
			const regex = new RegExp(`{${key}:*\\w*\\?*}`, 'gi');
			return path.replace(regex, value);
		}, relativePath);
	}
}
